"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToggle = exports.StyledToggleReplacementIcon = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem, getFontStyle } = ui_common_components_1.utils;
exports.StyledToggleReplacementIcon = styled_components_1.default.span `
  display: inline-flex;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};
`;
exports.StyledToggle = styled_components_1.default.button `
  white-space: nowrap;
  box-sizing: border-box;
  border: 1px solid transparent;
  cursor: pointer;
  display: inline-flex;
  flex: 1;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  ${getFontStyle('Body')}
  user-select: none;
  ${({ theme, active }) => (0, styled_components_1.css) `
    border-radius: ${rem(theme.Border.Radius.Medium)};
    flex-direction: 'row';
    gap: ${rem(theme.Spacing.Size.XSmall)};
    transition: all ${theme.Transition.Timing.Out};
    color: ${active ? theme.Color.Brand.Dark : theme.Color.Neutrals.Light};
    background: ${active ? theme.Color.Neutrals.Light : 'transparent'};
    max-height: ${rem(theme.Spacing.Size.XLarge)};
    max-width: ${rem(theme.Spacing.Size.XLarge)};
  `}

  &[disabled],
  &.disabled {
    pointer-events: none;
    color: ${({ theme }) => theme.Color.Neutrals.Text};
  }
  ${({ size }) => {
    switch (size) {
        case 'Small':
            return (0, styled_components_1.css) `
          min-height: ${({ theme }) => rem(theme.Spacing.Size.MediumLarge)};
          padding: ${({ theme }) => rem(theme.Spacing.Size.XXSmall + 2)}; // +2px to compensate for the border
        `;
        case 'Medium':
        default:
            return (0, styled_components_1.css) `
          min-height: ${({ theme }) => rem(theme.Spacing.Size.Large)};
          padding: ${({ theme }) => `${rem(theme.Spacing.Size.XSmall)} ${rem(theme.Spacing.Size.Small)}`};
        `;
    }
}}
`;
//# sourceMappingURL=ToggleReplacement.styles.js.map